import { AngularFireAuth } from "@angular/fire/compat/auth";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, from, Observable, switchMap } from "rxjs";
import { EncryptionService } from './encryption.service';

// utils function
import { requestToken } from "../../utils/auth.utils";

@Injectable({
  providedIn: "root",
})
export class PhotowallService {

  eventData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  userCurrentTime: any;
  userExpirationTime: any;
  refToken: any;
  encryptedData: any;
  decryptedData: any;
  constructor(private http: HttpClient, private afAuth: AngularFireAuth, private encryptionService: EncryptionService) { }


  async saveHashtags(eventId: any, showHashtag: any, hashtags: any, subtext: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("show_hashtag", showHashtag)
        .set("show_qrcode", 'null')
        .set("hashtag_subtext", subtext)
        .set("hashtags", hashtags.toString());

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://hbqop76py6.execute-api.us-west-1.amazonaws.com/pwa_photowall_save_hashtags",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("show_hashtag", showHashtag)
        .set("show_qrcode", 'null')
        .set("hashtag_subtext", subtext.toString())
        .set("hashtags", hashtags.toString());
      return this.http.post(
        "https://hbqop76py6.execute-api.us-west-1.amazonaws.com/pwa_photowall_save_hashtags",
        params.toString(),
        { headers }
      );
    }
  }

  async saveQRCodeData(eventId: any, showQRCode: any, subtext: any, qr_image: any, default_qrcode: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("show_hashtag", 'null')
        .set("show_qrcode", showQRCode)
        .set("qr_image", qr_image)
        .set("default_qrcode", default_qrcode)
        .set("qrcode_subtext", subtext);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://hbqop76py6.execute-api.us-west-1.amazonaws.com/pwa_photowall_save_hashtags",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("show_hashtag", 'null')
        .set("show_qrcode", showQRCode)
        .set("qr_image", qr_image)
        .set("default_qrcode", default_qrcode)
        .set("qrcode_subtext", subtext.toString());
      return this.http.post(
        "https://hbqop76py6.execute-api.us-west-1.amazonaws.com/pwa_photowall_save_hashtags",
        params.toString(),
        { headers }
      );
    }
  }


  async saveSponsorData(eventId: any, sponsorName: any, imageFrequency: any, fileNames: any, showSponsors: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("sponsor_name", sponsorName)
        .set("file_names", fileNames)
        .set("frequency", imageFrequency).set("show_sponsors", showSponsors);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://a5hxtiwle2.execute-api.us-west-1.amazonaws.com/pwa_photowall_save_sponsor_details",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("sponsor_name", sponsorName)
        .set("file_names", fileNames)
        .set("frequency", imageFrequency).set("show_sponsors", showSponsors);

      return this.http.post(
        "https://a5hxtiwle2.execute-api.us-west-1.amazonaws.com/pwa_photowall_save_sponsor_details",
        params.toString(),
        { headers }
      );
    }
  }

  async deleteSponsorData(eventId: any, id: any) {
    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    // Parse the JSON string
    //const user = JSON.parse(jsonString);
    const token: any = user?.stsTokenManager.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token);
      // .set("hex", localStorage.getItem("eventId") || "{}")
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("sponsor_id", id);

      // console.log({ headers }); //__CONSOLE_LOG__

      return this.http.post(
        "https://a6hhc4lk23.execute-api.us-west-1.amazonaws.com/pwa-delete-sponsor",
        params.toString(),
        { headers }
      );
    } else {
      // call utils function for token request
      const Reftoken = await requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken);
      const params = new HttpParams()
        .set("event_id", eventId.toString())
        .set("sponsor_id", id);

      return this.http.post(
        "https://a6hhc4lk23.execute-api.us-west-1.amazonaws.com/pwa-delete-sponsor",
        params.toString(),
        { headers }
      );
    }
  }

  getSponsorData(eventId: any): Observable<any> {
    const url = 'https://ireub0av97.execute-api.us-west-1.amazonaws.com/pwa_photowall_get_sponsordata';

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || '{}');
    const token: any = user?.stsTokenManager.accessToken;
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);

    const makeRequest = (authToken: string) => {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/x-www-form-urlencoded')
        .set('Authorization', authToken)
        .set('event_id', eventId);
      return this.http.get(url, { headers });
    };

    if (this.userCurrentTime < this.userExpirationTime) {
      return makeRequest(token);
    } else {
      return from(requestToken(this.afAuth)).pipe(
        switchMap((refreshedToken: any) => {
          if (refreshedToken) this.refToken = refreshedToken;
          return makeRequest(this.refToken);
        })
      );
    }
  }

  gethashtags(eventId: any): Observable<any> {
    // console.log(eventId); //__CONSOLE_LOG__

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", eventId)
      return this.http.get(
        "https://orwp7wx2m1.execute-api.us-west-1.amazonaws.com/pwa_photowall_get_hashtags",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", eventId)

      return this.http.get(
        "https://orwp7wx2m1.execute-api.us-west-1.amazonaws.com/pwa_photowall_get_hashtags",
        { headers }
      );

    }
  }

  getEventQR(eventId: any): Observable<any> {
    // console.log(eventId); //__CONSOLE_LOG__

    this.encryptedData = localStorage.getItem('user');
    this.decryptedData = this.encryptionService.decryptData(this.encryptedData);
    const user = JSON.parse(this.decryptedData || "{}");
    const token: any = user?.stsTokenManager.accessToken;
    // Add for AccessToken get
    const expirationTime = user?.stsTokenManager.expirationTime;
    const currentTime = new Date().getTime() / 1000;
    this.userCurrentTime = new Date(currentTime * 1000);
    this.userExpirationTime = new Date(expirationTime);
    // set headers
    if (this.userCurrentTime < this.userExpirationTime) {
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", token)
        .set("event_id", eventId)
      return this.http.get(
        "https://bb0s5kpma5.execute-api.us-west-1.amazonaws.com/pwa_get_event_qr",
        { headers }
      );

    } else {
      // call utils function for token request
      const Reftoken = requestToken(this.afAuth);
      if (Reftoken) {
        //   console.log(Reftoken);  
        this.refToken = Reftoken;
      }
      const headers = new HttpHeaders()
        .set("Content-Type", "application/x-www-form-urlencoded")
        .set("Authorization", this.refToken)
        .set("event_id", eventId)

      return this.http.get(
        "https://bb0s5kpma5.execute-api.us-west-1.amazonaws.com/pwa_get_event_qr",
        { headers }
      );

    }
  }

}
